/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailsvatid3Inputs */

const en_companydetailsvatid3 = /** @type {(inputs: Companydetailsvatid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VAT number (UID)`)
};

const de_companydetailsvatid3 = /** @type {(inputs: Companydetailsvatid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UID-Nummer`)
};

/**
* | output |
* | --- |
* | "VAT number (UID)" |
*
* @param {Companydetailsvatid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailsvatid3 = /** @type {((inputs?: Companydetailsvatid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailsvatid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailsvatid3(inputs)
	return de_companydetailsvatid3(inputs)
});
export { companydetailsvatid3 as "companyDetailsVatId" }